/* App config for apis
 */
const isLocal = window.location.hostname.includes("localhost");
const ApiConfig = {
  BASE_URL: isLocal ? "http://localhost:3000/api/" : "/api/", // '/api/'http://localhost:3000/api/
  LOGIN: `auth/login`,
  SERVER_LIST: `server`,
  CHECK_STATUS_SERVER: `server/check`,
  CONTACT_LIST: `contact`,
  CREATE_SERVER: "server",
  DETAIL_SERVER: "server",
  UPDATE_SERVER: "server",
  UPDATE_STATUS_SERVER: "server/status",
  DETAIL_CONTACT: "contact",
  CREATE_CONTACT: "contact",
  UPDATE_CONTACT: "contact",
  REMOVE_CONTACT: "contact",
  SEND_MAIL_TEST_TO_CONTACT: "contact/test-email",
  USER_LIST: `user`,
  DETAIL_USER: "user",
  CREATE_USER: "user",
  UPDATE_USER: "user",
  GET_LIST_NOTIFICATION: "tracking",
  GET_LASTEST_NOTIFICATION: "tracking",
};

export default ApiConfig;
